<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {

  name: 'App',
  mounted() {

  },
  methods: {

  }
}
</script>
<style>

</style>
<style lang="less" scoped>


  body{
    font-family: SourceHanSansCN, SourceHanSansCN;
  }
</style>
